import { useT } from "@/i18n";

// Body map — tap a region to cycle none → tense → neutral → open.
// Value: { marks: { [regionKey]: state } }. Labels via body_* i18n keys.
const ROWS = [
  ["head"],
  ["face"],
  ["throat"],
  ["shoulders", "chest", "arms"],
  ["upper_back", "heart"],
  ["solar_plexus"],
  ["lower_back", "belly"],
  ["hips"],
  ["pelvis"],
  ["legs"],
  ["feet"],
];

const STATE_COLOR = { none: "#E7E2DA", tense: "#D48A8A", neutral: "#E7CFA0", open: "#8FB3A0" };
const NEXT = { none: "tense", tense: "neutral", neutral: "open", open: "none" };

export function BodyMap({ value, onChange }) {
  const t = useT();
  const marks = value?.marks || {};
  const cycle = (k) => onChange({ marks: { ...marks, [k]: NEXT[marks[k] || "none"] } });

  return (
    <div>
      <p className="mb-3 text-sm text-muted-foreground">{t("bodymap_hint")}</p>
      <div className="mx-auto flex max-w-xs flex-col items-center gap-2">
        {ROWS.map((row, i) => (
          <div key={i} className="flex justify-center gap-2">
            {row.map((k) => {
              const m = marks[k] || "none";
              return (
                <button
                  key={k}
                  type="button"
                  data-testid={`body-${k}`}
                  onClick={() => cycle(k)}
                  className="rounded-full border border-border px-3 py-2 text-xs font-medium transition-colors"
                  style={{ backgroundColor: STATE_COLOR[m], color: m === "none" ? "#6B6B6B" : "#2B2B2B" }}
                >
                  {t(`body_${k}`)}
                </button>
              );
            })}
          </div>
        ))}
      </div>
      <div className="mt-4 flex justify-center gap-4">
        {[["tense", "body_mark_tense"], ["neutral", "body_mark_neutral"], ["open", "body_mark_open"]].map(([st, key]) => (
          <span key={st} className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: STATE_COLOR[st] }} /> {t(key)}
          </span>
        ))}
      </div>
    </div>
  );
}
